// @flow
import classnames from 'classnames';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import ExpandIcon from '../../../assets/icons/expand.svg';

const useStyles = makeStyles(theme => ({
  root: {
    background: 'transparent',
    border: 'none',
    outline: 'none',
    userSelect: 'none',
    '&:hover': {
      background: theme.palette.ava.grey5,
    },
  },
}));

interface Props {
  className?: string;
  onClick: Function;
}

const ExpandButton = ({ className, onClick }: Props) => {
  const classes = useStyles(0);

  return (
    <button className={classnames(classes.root, className)} onClick={onClick}>
      <img src={ExpandIcon} alt="Expand" />
    </button>
  );
};

export default ExpandButton;
